import { render, staticRenderFns } from "./AgeVerifyDialog.vue?vue&type=template&id=d0a0286a&scoped=true&"
import script from "./AgeVerifyDialog.vue?vue&type=script&lang=js&"
export * from "./AgeVerifyDialog.vue?vue&type=script&lang=js&"
import style0 from "./AgeVerifyDialog.vue?vue&type=style&index=0&id=d0a0286a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a0286a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
